





import { defineComponent } from '@vue/composition-api';
import api from '@/service';

export default defineComponent({
  setup() {
    const getData = async () => {
      const data = await api.login.getSysUserRole();
    };

    getData();
  },
});
